import { BmHttp as Http } from "../utils/Global";

export const PostNewPlan = async(payload) => {
    try {

        const { data } = await Http().post(`planes`, payload);
        return data;
        
    } catch (error) {
        return error.response.data;
    }
}

export const EliminarPlan = async (id) => {
    try {
        const { data } = await Http().post(`plan-eliminar`, { id_plan: id });
        return data;
    } catch (error) {
        return error.response.data;
    }
};

// CONFIG-PLANES-SEGURO-31: cambiar estado del plan sin borrarlo.
export const CambiarEstadoPlan = async (idplan, estado) => {
    try {
        const { data } = await Http().patch(`planes/${idplan}/estado`, { estado });
        return data;
    } catch (error) {
        // Ante error de red / preflight (sin `error.response`) devolver un shape
        // consistente en vez de reventar con "Cannot read properties of undefined".
        return error?.response?.data || { success: false, message: error?.message || "No se pudo contactar el servidor" };
    }
};

// CONFIG-PLANES-SEGURO-31: `params` opcional { seguro_id, search, estado }.
// Sin `estado` el backend devuelve solo planes Activos (combos operativos).
// Para listados históricos/reportes pasar { estado: "Todos" }.
export const ListadoPlanes = async(params = {}) => {
    try {

        const { data } = await Http().get(`planes`, { params });
        return data;

    } catch (error) {
        return error.response.data;
    }
}
export const PutUpdatePlan = async (idplan, payload) => {
    try {
        const { data } = await Http().put(`planes/${idplan}`, payload);
        return data;
    } catch (error) {
        return error.response.data;
    }
}
